
import NavOurServicesMixin from "~/mixins/navOurServices"

export default {
  name: "NavOurServices",
  extends: NavOurServicesMixin
}
